import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "search-search-result" }
const _hoisted_2 = { class: "text text-left" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  href: "javascript:void(0)",
  class: "io-mfe-ig-partial-code-result"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "code-text" }

import _ from 'lodash';
import {useSearchStore} from 'stores/search-store';
import {storeToRefs} from 'pinia';
import {SearchViewRecord} from 'src/services/searchService';
import {watch} from 'vue';
import { DATA_BOOK_REGEX } from 'src/components/grouper-common/common-constants';
import {useResourcesStore} from 'src/stores/resourcesStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultsList',
  setup(__props) {

const searchStore = useSearchStore();
const {searchResults, selectedSearchResult} = storeToRefs(searchStore);
const resourcesStore = useResourcesStore();
const notNil = _.negate(_.isNil);

watch(
  searchResults,
  (newSearchResults) => {
    if (newSearchResults && newSearchResults.length > 0) {
      //this is triggering even if searchResults is set to previous value
      searchStore.setSelectedSearchResult(newSearchResults[0])
    }
  });

function onClick(searchResult: SearchViewRecord, event: Event){
  if(event instanceof PointerEvent) onSelectionChanged(searchResult)
}
function onSelectionChanged(searchResult: SearchViewRecord) {
  searchStore.indexHistory.addToHistory(searchResult)
  searchStore.getResultDetails(searchResult);
  searchStore.setSelectedSearchResult(searchResult)
  
  const code = _.get(searchResult, 'codes[0]');
  const codeType = _.get(searchResult.data_book?.match(DATA_BOOK_REGEX), '[0]');
  if (notNil(code) && notNil(codeType)) {
    resourcesStore.getResearch(code as string, codeType as string);
  }
}
function onKeyboardPressed(event: KeyboardEvent){
  if (['ArrowUp', 'ArrowDown', 'Tab'].includes(event.key) && searchResults.value && selectedSearchResult.value){
    let currentIndex = searchResults.value.indexOf(selectedSearchResult.value)
    let updatedIndex = currentIndex;
    if (event.key === 'ArrowUp'){
      updatedIndex = currentIndex > 0 ? currentIndex - 1 : searchResults.value.length - 1;
    } else if (event.key === 'ArrowDown' || event.key === 'Tab'){
      updatedIndex = currentIndex < searchResults.value.length - 1 ? currentIndex + 1 : 0;
    }
    onSelectionChanged(searchResults.value[updatedIndex])
  }
}

function addCode(code?: string) {
  if (code) {
    searchStore.addDxOrProcCode(code);
  }
}

function shouldShowPlusAddCode(record: SearchViewRecord) {
  return record.groupable_codes?.[0] && !record.groupable_codes?.[0]?.endsWith('-') && (record?.groupable_codes?.[0]?.length === 7 || !searchStore.getBookCode?.startsWith('ICD10PCS'));
}

function shouldShowAddCode(record: SearchViewRecord) {
  return record?.codes?.[0] && !record?.codes?.[0]?.endsWith('-') && (record?.codes?.[0]?.length === 7 || !searchStore.getBookCode?.startsWith('ICD10PCS'));
}

function hasPartialCode(record: SearchViewRecord) {
  return record?.codes?.[0] && (record?.codes?.[0]?.endsWith('-') || (record?.codes?.[0]?.length != 7 && searchStore.getBookCode?.startsWith('ICD10PCS')));
}


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_list, {
      dense: "",
      modelValue: _unref(selectedSearchResult),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedSearchResult) ? (selectedSearchResult).value = $event : null)),
      onKeydown: onKeyboardPressed
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchResults) || [], (searchResultItem, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (searchResultItem.text)
              ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  key: 0,
                  clickable: "",
                  "manual-focus": "",
                  class: _normalizeClass('q-hoverable search-search-result-item' + (_unref(selectedSearchResult)?.data_id === searchResultItem.data_id ? ' search-search-result-item__active' : '')),
                  onClick: ($event: any) => (onClick(searchResultItem, $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { class: "search-search-result-item-section" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", {
                            innerHTML: searchResultItem.text
                          }, null, 8, _hoisted_3),
                          (hasPartialCode(searchResultItem))
                            ? (_openBlock(), _createElementBlock("a", _hoisted_4, _toDisplayString(searchResultItem?.codes?.[0]), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (shouldShowAddCode(searchResultItem))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["code-wrapper", {'code-wrapper-clickable': shouldShowPlusAddCode(searchResultItem)}]),
                              onClick: _withModifiers(($event: any) => (shouldShowPlusAddCode(searchResultItem) && addCode(searchResultItem?.codes?.[0])), ["stop"])
                            }, [
                              (shouldShowPlusAddCode(searchResultItem))
                                ? (_openBlock(), _createBlock(_component_q_icon, {
                                    key: 0,
                                    class: "code-icon",
                                    name: "fa-light fa-circle-plus",
                                    size: "14px"
                                  }))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_6, _toDisplayString(searchResultItem?.codes?.[0]), 1)
                            ], 10, _hoisted_5))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"])), [
                  [_directive_ripple, _unref(selectedSearchResult)?.data_id === searchResultItem.data_id]
                ])
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})